module.exports = __webpack_public_path__ + "img/17.60887926.jpg";